export enum AppTheme {
  Light = "light",
  Dark = "dark",
}
